import { render, staticRenderFns } from "./_form.vue?vue&type=template&id=53ec212e&scoped=true&"
import script from "./_form.vue?vue&type=script&lang=js&"
export * from "./_form.vue?vue&type=script&lang=js&"
import style0 from "./_form.vue?vue&type=style&index=0&id=53ec212e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec212e",
  null
  
)

export default component.exports